import axios from "axios";
import { getClientId } from "../shared/flavours/useFlavour";

import i18n from "@/i18n";
import { RegisterFlagsT } from "./login";

const clientId = getClientId();

export const register = async (
  username: string,
  password: string,
  signInUrl: string,
  deviceMetadata: string,
  deviceSignupMetadata: string,
  flags: RegisterFlagsT
) => {
  const newUser = {
    email: username.trim(),
    password: password.trim(),
    signInUrl,
    originalDeviceMetadata: deviceSignupMetadata,
    latestDeviceMetadata: deviceMetadata,
    ...flags,
    clientId: clientId || "",
  };

  return axios
    .post<string>(`${process.env.API_SERVER_URL}/users`, newUser)
    .then((response) => {
      const location = response.headers?.location;
      const userId = typeof location === "string" && location.split("/").slice(-1)[0];

      if (typeof userId === "string") {
        return userId;
      }

      throw new Error(i18n.t("errors.noUserIdCreated") || undefined);
    })
    .catch((error) => {
      if (error.response && error.response?.data) {
        const { fieldErrors } = error.response.data;

        if (Array.isArray(fieldErrors)) {
          fieldErrors.forEach(({ messageIds = [] }) => {
            messageIds.forEach((messageId: string) => {
              switch (messageId) {
                case "user.email.already_exists":
                  throw new Error(i18n.t("auth.errors.userEmailAlreadyExists") || undefined);
                case "user.email.already_exists_as_social_user":
                  throw new Error(i18n.t("auth.errors.userSocialEmailAlreadyExists") || undefined);
                default:
              }
            });
          });
        }
      }
      throw new Error(error);
    });
};
